import type { FC } from 'react';
import { DocumentationLink } from '@gonfalon/docs/DocumentationLink';
import { getSdkInfoByKey } from '@gonfalon/sdk-info/sdkInfo';
import { Text } from '@launchpad-ui/components';

import { useOnboardingStorage } from '../../hooks';
import { getSdkDocumentationUrl } from '../../utils/docs';

import { InitializeSDK, isInitializableSdk } from './initialization/InitializeSDK';

import styles from './SdkInitInstructions.module.css';

export const SdkInitInstructions: FC = () => {
  const { sdk, sdkInitKeys, memberId, isLoadingSdkKeys } = useOnboardingStorage();

  if (isInitializableSdk(sdk)) {
    return <InitializeSDK sdk={sdk} sdkInitKeys={sdkInitKeys} memberId={memberId} loading={isLoadingSdkKeys} />;
  }

  const sdkInfo = getSdkInfoByKey(sdk);

  return (
    <div className={styles.initInstructions}>
      <Text>
        Follow the steps on{' '}
        <DocumentationLink
          href={getSdkDocumentationUrl(sdk)}
          text={`${sdkInfo.name} docs`}
          component="SdkInitInstructions"
        />
        .
      </Text>
    </div>
  );
};
